import React from 'react';
import { EARTH_MODES } from '../../../constants/games/zoomedInEarthGame';

const EarthModeSelector = ({ mode, onChange, disabled }) => (
  <div className="earth-mode-selector" role="radiogroup" aria-label="Earth game mode">
    {EARTH_MODES.map((m) => {
      const active = mode === m.key;
      return (
        <button
          key={m.key}
          type="button"
          role="radio"
          aria-checked={active}
          className={`earth-mode-btn ${active ? 'is-active' : ''}`.trim()}
          disabled={disabled}
          onClick={() => onChange(m.key)}
        >
          <span className="earth-mode-btn-title">{m.label}</span>
          <span className="earth-mode-btn-subtitle">{m.subtitle}</span>
        </button>
      );
    })}
  </div>
);

export default React.memo(EarthModeSelector);
